module.exports = shared.jquery;